// extracted by mini-css-extract-plugin
export var cardSelected = "_hz-2";
export var image = "_hz-1";
export var table = "_hz-0";